export default __webpack_public_path__ + "static/media/max_koenig.dfdc7f44.jpg";